import { render, staticRenderFns } from "./tongzhigonggao.vue?vue&type=template&id=6e4ef2a6&scoped=true"
import script from "./tongzhigonggao.js?vue&type=script&lang=js&external"
export * from "./tongzhigonggao.js?vue&type=script&lang=js&external"
import style0 from "./tongzhigonggao.scss?vue&type=style&index=0&id=6e4ef2a6&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4ef2a6",
  null
  
)

export default component.exports